
// @ts-ignore
import {getConfig, getLanguageConfig} from "../../utils/config-helper";
// @ts-ignore
import {translate} from '@elements/translations';
import {ref, computed, reactive, onMounted, defineComponent} from 'vue';

export default defineComponent({
    name: "SeasonsLegend",
    setup(props) {
        const seasons = computed(() => {
            return getConfig('seasons');
        });

        return {
            seasons,
            translate
        }
    }
});
